/* THEORIC - Metricas por secao (home e pagina A Theoric).
   Envia para o dataLayer (GTM/GA4) e para o Clarity:
   - theoric_secao_vista: a secao ficou 50% visivel pela primeira vez.
   - theoric_secao_clique: clique em link ou botao dentro de uma secao.
   Parametros: pagina (home | a_theoric), secao (chave da secao no template),
   posicao (ordem na pagina), rotulo e destino (so no clique).
   Nao envia dado pessoal: campos de formulario sao ignorados. */
(function () {
  if (window.__theoricSecaoMetricas) return;
  window.__theoricSecaoMetricas = true;

  var script = document.currentScript;
  var pagina = (script && script.dataset.pagina) || 'outra';
  var sections = Array.prototype.slice.call(document.querySelectorAll('#MainContent > .shopify-section'));
  if (!sections.length) return;

  function key(el) {
    var id = el.id || '';
    var i = id.indexOf('__');
    return i > -1 ? id.slice(i + 2) : id.replace('shopify-section-', '');
  }

  function push(event, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: event, pagina: pagina }, data));
      if (window.clarity) window.clarity('event', event + ':' + data.secao);
    } catch (e) { /* metricas nunca quebram a pagina */ }
  }

  var visiveis = sections.filter(function (s) { return s.offsetHeight > 0; });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        push('theoric_secao_vista', { secao: key(e.target), posicao: visiveis.indexOf(e.target) + 1 });
      });
    }, { threshold: 0.5 });
    visiveis.forEach(function (s) { io.observe(s); });
  }

  document.addEventListener('click', function (e) {
    var alvo = e.target.closest && e.target.closest('a[href], button');
    if (!alvo) return;
    var sec = alvo.closest('#MainContent > .shopify-section');
    if (!sec) return;
    if (alvo.matches('button') && alvo.closest('form')) return;
    var rotulo = (alvo.getAttribute('aria-label') || alvo.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80);
    push('theoric_secao_clique', {
      secao: key(sec),
      posicao: visiveis.indexOf(sec) + 1,
      rotulo: rotulo,
      destino: alvo.getAttribute('href') || ''
    });
  }, true);
})();
